import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Custom
import { refreshList } from 'actions';
import MainViewTemplate from 'components/templates/MainViewTemplate';
import { RefreshTextButton } from 'components/buttons/TextButtons';
import ListTemplate from './ListTemplate';

const MainListTemplate = ({
  title,
  icon,
  displayRefresh,
  actionButtons,
  contentMaxWidth,
  withPadding,
  handleRefreshList,
  ...otherProps
}) => {
  // All buttons
  const buttons = actionButtons || [];
  if (displayRefresh) {
    buttons.push(<RefreshTextButton key="refresh" primary onClick={handleRefreshList} />);
  }

  return (
    <MainViewTemplate
      title={title}
      icon={icon}
      buttons={buttons}
      withPadding={withPadding}
      contentMaxWidth={contentMaxWidth}
    >
      <ListTemplate {...otherProps} />
    </MainViewTemplate>
  );
};

MainListTemplate.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  icon: PropTypes.string,
  displayRefresh: PropTypes.bool,
  withPadding: PropTypes.bool,
  actionButtons: PropTypes.arrayOf(PropTypes.element),
  contentMaxWidth: PropTypes.number,
  handleRefreshList: PropTypes.func.isRequired,
};

MainListTemplate.defaultProps = {
  icon: null,
  displayRefresh: false,
  withPadding: true,
  actionButtons: null,
  contentMaxWidth: null,
};

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
});

module.exports = connect(
  null,
  mapDispatchToProps,
)(MainListTemplate);



// WEBPACK FOOTER //
// ./components/templates/MainListTemplate.js